import { CommentQuestionIcon } from './CommentQuestionIcon';

/**
 * author: Austin Andrews
 * id 49412CCB-C5F6-460F-A2DB-76BCCB668BCC
 * name comment-question
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-question.svg
 * tags
 */
export const CommentHelpIcon = CommentQuestionIcon;
export default CommentHelpIcon